import React from 'react';

export default function PlaylistIcon({ fill = '#FFF', stroke = '#FFF', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_429_11182)">
                <path d="M6 6L3 7.73205L3 4.26795L6 6Z" stroke={stroke} strokeWidth="2.5" strokeLinejoin="round" />
                <path d="M3 12L21 12" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 6L21 6" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3 18L21 18" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_429_11182">
                    <rect width="24" height="24" fill={fill} />
                </clipPath>
            </defs>
        </svg>
    );
}
